export enum EFilterType {
  // 基础类型
  /**
   * 单选按钮
   */
  Radio = 1,

  /**
   * 多选框
   */
  Checkbox = 2,

  /**
   * 下拉框
   */
  Select = 3,

  /**
   * 输入框
   */
  Input = 4,

  /**
   * 范围输入框
   */
  InputRange = 5,

  // 特殊业务类型
  /**
   * 单选和多选组合
   * @description  默认单选。
   */
  RadioWithCheckbox = 6,

  /**
   * 类目型单选和多选
   * @description 。类目单选、类目多选  类目单选单列时有搜索框
   * @deprecated
   * 例如 牌号
   */
  CategoryTab = 7,

  /**
   * 规格
   * @description 基础类型组合。pc端中下拉框会联动输入框
   */
  Specification = 8,

  /**
   * 件重
   */
  BalanceWeight = 9,

  /**
   * 产地
   * @description 卡片(选框)式单选和卡片式多选
   * 例如 产地
   */
  Manufacture = 10,

  /**
   * 存放地
   * @description 产地信息。使用首字符分类
   */
  StoreCity = 11,

  /**
   * 验证
   */
  Flag = 12,

  /**
   * 产品属性
   */
  ProductProp = 13,

  /**
   * 下拉框式输入框
   */
  DropdownInput = 14,
  /**
   * 下拉框式范围输入框
   */

  DropdownInputRange = 15,
  /**
   * 时间选择
   */
  DatePicker = 16,
}



// WEBPACK FOOTER //
// ./src/enums/EFilterType.ts